import React, { useState, useEffect } from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    CardFooter,
    Table,
    Col,
    Row,
    Button,
    Input,
    Label,
    Spinner,
    Badge
} from "reactstrap";
import MembersService from "../services/staff.service"
import CreateMember from "../features/Members/CreateMember"
import MemberDetails from "../features/Members/MemberDetails"

import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

function Staff() {
    const [listMembers, setListMembers] = useState([])
    const [page, setPage] = useState('')
    const [dataProps, setDataProps] = useState([])
    const [search, setSearch] = useState("")
    const [listDataFilter, setListDataFilter] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        loadMembers();
    }, [])

    function loadMembers() {
        setLoading(true);
        MembersService.getMembers().then((result) => {
            setListMembers(result.data)
            setListDataFilter(result.data)
        }).catch((error) => {
            Swal.fire('Lỗi!', `Không thể tải dữ liệu: ${error}`, 'error');
        }).finally(() => {
            setLoading(false);
        })
    }

    function toDetailView(val) {
        setPage('detail')
        setDataProps(val)
    }

    /**
     * 🔍 Filter by search
     */
    const filteredMembers = listMembers.filter(m => {
        if (!search) return true;
        const q = search.toLowerCase();
        return (
            (m.username && m.username.toLowerCase().includes(q)) ||
            (m.email && m.email.toLowerCase().includes(q)) ||
            (m.fullname && m.fullname.toLowerCase().includes(q)) ||
            (m.role && m.role.toLowerCase().includes(q)) ||
            (m.id && m.id.toString().includes(q))
        );
    });

    /**
     * 🏷️ Render role badge
     */
    function renderRoleBadge(role) {
        const roleMap = {
            'admin': { color: '#e74c3c', bg: 'rgba(231,76,60,0.1)', label: 'Admin' },
            'manager': { color: '#e67e22', bg: 'rgba(230,126,34,0.1)', label: 'Manager' },
            'moderator': { color: '#3498db', bg: 'rgba(52,152,219,0.1)', label: 'Moderator' },
            'staff': { color: '#27ae60', bg: 'rgba(39,174,96,0.1)', label: 'Staff' },
        };
        const r = roleMap[role?.toLowerCase()] || { color: '#6c757d', bg: 'rgba(108,117,125,0.1)', label: role };
        return (
            <span style={{
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '13px',
                fontWeight: '600',
                color: r.color,
                backgroundColor: r.bg
            }}>
                {r.label}
            </span>
        );
    }

    // Shared styles
    const cardStyle = {
        borderRadius: '20px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        border: 'none',
        overflow: 'hidden',
        margin: '0 auto'
    };

    const thStyle = {
        border: 'none',
        fontSize: '14px',
        color: '#8898aa',
        fontWeight: '600',
        textTransform: 'uppercase'
    };

    return (
        <div className="content">
            {page === 'create' ? (
                <>
                    <Button color="info" onClick={() => setPage('')} style={{ borderRadius: '20px', marginBottom: '10px' }}>
                        <i className="fas fa-chevron-left" style={{ marginRight: '6px' }} /> Quay lại
                    </Button>
                    <CreateMember />
                </>
            ) : page === 'detail' ? (
                <>
                    <Button color="info" onClick={() => setPage('')} style={{ borderRadius: '20px', marginBottom: '10px' }}>
                        <i className="fas fa-chevron-left" style={{ marginRight: '6px' }} /> Quay lại
                    </Button>
                    <MemberDetails data={dataProps} />
                </>
            ) : (
                <Card style={cardStyle}>
                    <CardHeader style={{
                        background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                        padding: '20px 24px',
                        borderBottom: 'none',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <i className="fas fa-users" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
                            <div style={{ lineHeight: '1.3' }}>
                                <Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>
                                    Quản lý nhân viên
                                </Label>
                                <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
                                    {listMembers.length > 0 ? `${listMembers.length} nhân viên` : 'Đang tải...'}
                                </span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ position: 'relative' }}>
                                <i className="fas fa-search" style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: 'rgba(255,255,255,0.6)',
                                    fontSize: '15px',
                                    zIndex: 1
                                }}></i>
                                <Input
                                    style={{
                                        height: "38px",
                                        borderRadius: '20px',
                                        border: 'none',
                                        fontSize: '14px',
                                        backgroundColor: 'rgba(255,255,255,0.2)',
                                        color: '#fff',
                                        backdropFilter: 'blur(4px)',
                                        paddingLeft: '36px',
                                        width: '220px'
                                    }}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Tìm kiếm..."
                                />
                                <style>{`.content input::placeholder { color: rgba(255,255,255,0.6) !important; }`}</style>
                            </div>
                            <Button
                                onClick={() => setPage('create')}
                                style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: '#fff',
                                    borderRadius: '20px',
                                    padding: '8px 16px',
                                    fontSize: '14px',
                                    fontWeight: '600'
                                }}
                            >
                                <i className="fas fa-plus" style={{ marginRight: '6px' }}></i> Thêm mới
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody style={{ padding: '16px 24px', overflowY: 'auto', overflowX: 'hidden' }}>
                        {loading ? (
                            <div className="text-center py-4">
                                <Spinner color="primary" />
                            </div>
                        ) : (
                            <Table style={{ marginTop: '10px', marginBottom: 0 }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #f0f0f0' }}>
                                        <th style={{ ...thStyle, width: '60px' }}>ID</th>
                                        <th style={thStyle}>Tài khoản</th>
                                        <th style={thStyle}>Email</th>
                                        <th style={thStyle}>Họ tên</th>
                                        <th style={thStyle}>Quyền</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredMembers.map((data, key) => (
                                        <tr
                                            onClick={() => toDetailView(data)}
                                            style={{
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f5f5f5',
                                                transition: 'background-color 0.2s ease'
                                            }}
                                            key={key}
                                            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                            onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <td style={{ border: 'none', verticalAlign: 'middle', fontSize: '14px', color: '#8898aa' }}>
                                                #{data.id}
                                            </td>
                                            <td style={{ border: 'none', verticalAlign: 'middle' }}>
                                                <span style={{ fontSize: '15px', fontWeight: '600', color: '#2c3e50' }}>
                                                    {data.username}
                                                </span>
                                            </td>
                                            <td style={{ border: 'none', verticalAlign: 'middle', fontSize: '14px', color: '#525f7f' }}>
                                                {data.email || <span style={{ color: '#d4d4d4' }}>—</span>}
                                            </td>
                                            <td style={{ border: 'none', verticalAlign: 'middle', fontSize: '15px', color: '#525f7f' }}>
                                                {data.fullname}
                                            </td>
                                            <td style={{ border: 'none', verticalAlign: 'middle' }}>
                                                {renderRoleBadge(data.role)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </CardBody>
                </Card>
            )}
        </div>
    )
}

export default Staff